import {useContext} from 'react';
import {useTranslation} from 'react-i18next';

import {AgentChatbot} from 'components';
import {ACTIVITY_NAME_TRANSLATE} from 'constants/session';
import {UserSessionContext} from 'context';
import {SessionActivityName} from 'interfaces';

import {SidebarView} from '../../types';
import {SidebarContent} from '../SidebarContent';

export const AgentChatbotSidebar: React.FC = () => {
    const {t} = useTranslation();
    const {session, agentChatbotThreads, askAgentChatbot} = useContext(UserSessionContext);

    return (
        <SidebarContent
            view={SidebarView.AgentChatbot}
            header={
                <div className='tw-ts-h5'>
                    {t(ACTIVITY_NAME_TRANSLATE[SessionActivityName.AgentChatbot])}
                </div>
            }
        >
            <AgentChatbot
                session={session}
                threads={agentChatbotThreads}
                onAsk={askAgentChatbot}
            />
        </SidebarContent>
    );
};
